import { Plaque } from "./Plaque";
import { shortWallet, useTopTouchers } from "./useLeaderboard";

/**
 * Wall-mounted leaderboard for top touchers in the current round.
 *
 * Data flows: @solblox/api -> useTopTouchers -> here.
 * Cache busts arrive via Colyseus `leaderboard:bust` messages and trigger a
 * refetch inside the hook.
 */

interface LeaderboardPlaqueProps {
  position: [number, number, number];
  rotation?: [number, number, number];
  /** Active KotH round id; null when no round is live. */
  roundId: number | null;
  gameId?: string;
}

const PLACEHOLDER_ROWS = ["(no round yet)"];

export function LeaderboardPlaque({
  position,
  rotation,
  roundId,
  gameId = "koth",
}: LeaderboardPlaqueProps): JSX.Element {
  const { rows, error } = useTopTouchers({ gameId, roundId, limit: 5 });

  let lines: string[];
  if (roundId === null) {
    lines = PLACEHOLDER_ROWS;
  } else if (error && rows.length === 0) {
    lines = ["(offline)"];
  } else if (rows.length === 0) {
    lines = ["(no touches yet)"];
  } else {
    lines = rows.map(
      (r, i) => `${i + 1}. ${shortWallet(r.toucher)}   ${r.touches}`,
    );
  }

  return (
    <Plaque
      position={position}
      rotation={rotation}
      width={3.4}
      height={2.6}
      backerColor="#1f1f2a"
      title="TOP TOUCHERS"
      titleColor="#f4d36a"
      titleSize={0.22}
      lines={lines}
      bodyColor="#e8e8ef"
      bodySize={0.2}
      align="left"
    />
  );
}
